import { ImportStatus } from './constants';

export const isImportAdded = (value) => value !== ImportStatus.PENDING;
export const isImportLoading = (value) => value !== ImportStatus.LOADED;
export const isImportFinished = (value) => value === ImportStatus.LOADED;
